import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MagicLinkStore } from '../../data/magic-link/magic-link.store';
import { ButtonComponent, FormTextComponent, IconComponent } from '../../ui-common';

// Landing page for the link in the inspection email: confirm the business, then verify a one-time code.
@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.html',
  styleUrl: './start-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, ButtonComponent, FormTextComponent, IconComponent],
})
export class StartPage implements OnInit {
  protected store = inject(MagicLinkStore);
  private router = inject(Router);

  linkId = input.required<string>();

  protected form = new FormGroup({
    code: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.minLength(6)],
    }),
  });

  async ngOnInit(): Promise<void> {
    if (await this.store.openLink(this.linkId())) this.router.navigate(['/inspection']);
  }

  protected async verify(): Promise<void> {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    if (await this.store.verify(this.form.controls.code.value)) this.router.navigate(['/inspection']);
  }
}
